import { Scroll, Check, Circle } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { Quest } from '@/lib/game-logic/templates';

interface QuestTrackerProps {
  quest: Quest;
  completedFlags: Set<string>;
}

export function QuestTracker({ quest, completedFlags }: QuestTrackerProps) {
  let firstIncompleteFound = false;

  return (
    <div className="px-4 py-3 border-b border-white/10">
      <div className="flex items-center gap-2 mb-2">
        <Scroll className="w-3.5 h-3.5 text-amber-400 shrink-0" />
        <h3 className="text-xs font-semibold text-amber-400 uppercase tracking-wide">
          {quest.name}
        </h3>
      </div>

      <ul className="space-y-1">
        {quest.objectives.map(obj => {
          const done = completedFlags.has(obj.flag);
          const isCurrent = !done && !firstIncompleteFound;
          if (isCurrent) firstIncompleteFound = true;

          return (
            <li key={obj.id} className="flex items-start gap-2">
              {done ? (
                <Check className="w-3.5 h-3.5 text-emerald-500 shrink-0 mt-0.5" />
              ) : (
                <Circle className={cn(
                  'w-3.5 h-3.5 shrink-0 mt-0.5',
                  isCurrent ? 'text-amber-400/60' : 'text-neutral-600',
                )} />
              )}
              <span className={cn(
                'text-xs leading-relaxed',
                done && 'line-through text-neutral-600',
                !done && isCurrent && 'text-neutral-300',
                !done && !isCurrent && 'text-neutral-500',
              )}>
                {obj.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
